// Static configuration for the "Stock Allocation Planner" page.
//
// CHANNEL_OPTIONS pairs the user-facing channel label with the underlying DRR
// column key that lives inside each `row.allocations` object returned by the API.

export const CHANNEL_OPTIONS = [
  { value: 'AZ DRR',      label: 'Amazon' },
  { value: 'FK DRR',      label: 'Flipkart' },
  { value: 'FK Mins DRR', label: 'Flipkart Minutes' },
  { value: 'Blinkit DRR', label: 'Blinkit' },
  { value: 'W.in DRR',    label: 'W.in' },
  { value: 'Zepto DRR',   label: 'Zepto' },
  { value: 'Meesho DRR',  label: 'Meesho' },
  { value: 'B2B DRR',     label: 'Offline' },
];

export const ALL_CHANNEL_VALUES = CHANNEL_OPTIONS.map((o) => o.value);
